import { Anchor } from "@newsela/angelou";

import LoadingShimmerMapper from "@/components/LoadingShimmerMapper/LoadingShimmerMapper";
import WarningIcon from "@/icons/WarningIcon";
import useAdvisoryMessageGet from "../../district/hooks/useAdvisoryMessageGet";
import {
  containerCss,
  headingCss,
  iconCss,
  textBodyCss,
} from "./ContentAdvisoryBanner.style";

const ContentAdvisoryBanner = () => {
  const {
    data: { body, title, hyperlink, loading },
  } = useAdvisoryMessageGet();
  return (
    <div style={containerCss}>
      <WarningIcon css={iconCss} />
      <div>
        <LoadingShimmerMapper loading={loading}>
          <h4 css={headingCss}>{title}</h4>
          <div css={textBodyCss}>{body}</div>
          {hyperlink ? (
            <Anchor href={hyperlink?.url}>{hyperlink?.text}</Anchor>
          ) : null}
        </LoadingShimmerMapper>
      </div>
    </div>
  );
};

export default ContentAdvisoryBanner;
